import React, { useState, useEffect } from 'react';

import { Breadcrumb } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';

import DocumentationService from 'Services/DocumentationService';

const DeleteDocumentation = (props) => {
    const history = useHistory();
    const {
        match: { params },
    } = props;
    const [documentation, setDocumentation] = useState(null);

    useEffect(() => {
        if (params.documentationId) {
            DocumentationService.getDocumentationById(params.documentationId)
                .then((result) => {
                    if (result.status === 200) {
                        setDocumentation(result.data);
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        }
    }, [params.documentationId]);

    const onDelete = () => {
        DocumentationService.deleteDocumentation(params.documentationId)
            .then((result) => {
                if (result.status === 200) {
                    history.push('/admin/documentation/index');
                }
            })
            .catch((e) => {
                console.log(e);
            });
    };

    return (
        <>
            <Breadcrumb className="mt-3">
                <Breadcrumb.Item>
                    <Link to="/">Home</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    <Link to="/admin">Admin</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    <Link to="/admin/documentation/index">Documentation</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item active>Delete</Breadcrumb.Item>
            </Breadcrumb>
            <div className="row py-3">
                <div className="col text-center">
                    <h2 className="mb-0">Delete Documentation</h2>
                    <i style={{ fontSize: '8pt', fontStyle: 'unset' }}>{params.documentationId}</i>
                </div>
            </div>
            <div className="row">
                <div className="col-md-3"></div>
                <div className="col-md-6 d-flex flex-column align-items-center">
                    <img src="/images/alert.svg" alt="" style={{ width: '100pt' }} className="d-block" />
                    <h4 className="py-3">Irreversible Action</h4>
                    <button className="btn btn-danger" onClick={onDelete}>
                        Delete {documentation && documentation.name}
                    </button>
                </div>
                <div className="col-md-3"></div>
            </div>
        </>
    );
};

export default DeleteDocumentation;
